import {Component} from '@angular/core';

@Component({
  selector: 'app-error-logout',
  templateUrl: './error-logout.component.html',
  styleUrls: ['./error-logout.component.scss'],
})
export class ErrorLogoutComponent {}
